import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private _applicationInsightsService: ApplicationInsightsService) {
    super();
  }

  override handleError(error: Error) {
    this._applicationInsightsService.logException(error);
    if (environment.production) {
      console.error('An unexpected error occurred. Please contact support.');
    } else {
      console.error(error);
    }
  }
}
